import { inject } from '@angular/core';
import { CatalogService } from '@partners/catalog';
import { IHttpOptions } from '@partners/http';
import { isEmptyObject } from '@partners/utils';
import { CustomerFacade } from '../../facades/customer';
import { PolicyService, ProfileService } from '../services';

export const policyGuard = async (options: IHttpOptions = {}): Promise<boolean> => {
  const policyService = inject(PolicyService);
  const customerFacade = inject(CustomerFacade);
  const isLoan$$ = inject(ProfileService).matchLoan;
  const catalogService = inject(CatalogService);

  const policyResult = await policyService.loadPolicy();

  // call customer "once" if loan
  if (isLoan$$() && !customerFacade.hasCustomerResponse$$()) {
    // loadCustomer uses loadFinance data - its for synchronized.
    await catalogService.loadFinance(options);

    await customerFacade.loadCustomer();
  }

  return !isEmptyObject(policyResult);
};
